import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { Notification } from '@/lib/types'
import { useAuth } from '@/features/auth/use-auth'

const PAGE_SIZE = 20

export function useNotifications() {
  const { user } = useAuth()
  return useQuery({
    queryKey: ['notifications', 'latest'],
    enabled: !!user,
    queryFn: async () => (await api.get<Notification[]>('/notifications')).data ?? [],
  })
}

export function useAllNotifications(enabled: boolean) {
  return useInfiniteQuery({
    queryKey: ['notifications', 'all'],
    enabled,
    initialPageParam: 0,
    queryFn: async ({ pageParam }) =>
      (await api.get<Notification[]>('/notifications', { params: { limit: PAGE_SIZE, offset: pageParam } })).data ?? [],
    getNextPageParam: (last, pages) => (last.length < PAGE_SIZE ? undefined : pages.flat().length),
  })
}

export function useMarkAllRead() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => api.post('/notifications/mark-all-read', {}),
    // v1 refetched on close so the badge cleared after the list was seen
    onSettled: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  })
}
